import React, { useCallback, useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import Card from '../../../components/Card'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { formatRupiah } from '../../../utilities/Utils'
import { FaEdit, FaTrash } from 'react-icons/fa'
import SweetAlert from 'react-bootstrap-sweetalert'

const ExpandableComponentNonLalinPeriksa = ({ data }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listData, setListData] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchAllData = useCallback(async () => {
            setLoading(true)
            try {
                const _resDtlPeriksa = await nonLalinService.listNonlalinDtlPeriksaAll(data.trNonlalinDtlPK.nomorAju, data.trNonlalinDtlPK.seri)
                // console.log(_resDtlPeriksa)
                setListData(_resDtlPeriksa.data.data)
            } catch (error) {
                setListData([])
            }
            setLoading(false)
    }, [nonLalinService, data])

    useEffect(() => {
        if (!data) return
        fetchAllData()
    }, [fetchAllData, data])

    const columns = [
        {
            name: 'Seri Tarif',
            cell: row => row['trNonlalinDtlPeriksaPK'].seriTarif,
            grow: 0.1
        },
        {
            name: 'Jenis Pengujian',
            cell: row => row['nmTarif']
        },
        {
            name: 'Tarif',
            cell: row => formatRupiah(row['tarif'])
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        },
        {
            name: 'Volume',
            cell: row => row['volume'],
            grow: 0.2
        },
        {
            name: 'Total Tarif',
            cell: row => formatRupiah(row['totalTarif'])
        },
        {
            name: 'Kesiapan Cek UPT',
            cell: row => row['isUptCanCheck'] === 'Y' ? <><span className='text-success'>Siap Diperiksa UPT</span></> : <><span className='text-danger'>Tidak Siap Diperiksa UPT</span></>
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        {localStorage.getItem('isEditStorage') === '1' ?
                            <div className='col-12 mb-1'>
                                {/* <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah</Tooltip>}>
                                    <Button size='sm' variant='warning'>
                                        <FaEdit />
                                    </Button>
                                </OverlayTrigger>{' '} */}
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Hapus</Tooltip>}>
                                    <Button size='sm' variant='danger' onClick={() => handleShowConfirmDelete(row)}>
                                        <FaTrash /> Hapus
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div> : ''
                        }
                        {
                            localStorage.getItem('isEditStorage') === '1' && localStorage.getItem('role') !== '4' && localStorage.getItem('role') !== '5' && row['isUptCanCheck'] === 'Y' &&
                            <div className='col-12 mb-1'>
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Tidak Tersedia</Tooltip>}>
                                    <Button size='sm' variant='warning' onClick={() => handleShowConfirmNoReady(row)}>
                                        <FaEdit /> Tidak Tersedia
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        }
                        {
                            localStorage.getItem('isEditStorage') === '1' && localStorage.getItem('role') !== '4' && localStorage.getItem('role') !== '5' && row['isUptCanCheck'] === 'T' &&
                            <div className='col-12 mb-1'>
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Tersedia</Tooltip>}>
                                    <Button size='sm' variant='primary' onClick={() => handleShowConfirmReady(row)}>
                                        <FaEdit /> Tersedia
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        }
                    </div>
                </>
            )
        }
    ]

    const [dataDtlPeriksa, setDataDtlPeriksa] = useState(null)
    const [showConfirmNotReady, setShowConfirmNotReady] = useState(false)
    const handleCloseConfirmNotReady = () => setShowConfirmNotReady(false)
    const handleShowConfirmNoReady = (row) => {
        setDataDtlPeriksa(row)
        setShowConfirmNotReady(true)
    }
    const [loadingNotReady, setLoadingNotReady] = useState(false)
    const [showSaveNotReadySuccess, setShowSaveNotReadySuccess] = useState(false)
    const [showSaveNotReadyFailed, setShowSaveNotReadyFailed] = useState(false)

    const handleClickSaveNotReady = async () => {
        setLoadingNotReady(true)
        try {
            let jsonDtlPeriksa = {
                ...dataDtlPeriksa,
                isUptCanCheck: 'T'
            }
            const res = await nonLalinService.saveNonlalinDtlPeriksa(jsonDtlPeriksa)
            if (res.data.kode === '200') {
                setShowConfirmNotReady(false)
                setShowSaveNotReadySuccess(true)
            } else {
                setShowConfirmNotReady(false)
                setShowSaveNotReadyFailed(true)
            }
        } catch (error) {
            setShowConfirmNotReady(false)
            setShowSaveNotReadyFailed(true)
        }
        setLoadingNotReady(false)
    }

    const handleClickSaveNotReadySuccess = () => {
        fetchAllData()
        setShowSaveNotReadySuccess(false)
    }

    const handleClickSaveNotReadyFailed = () => {
        setShowSaveNotReadyFailed(false)
    }

    const [showConfirmReady, setShowConfirmReady] = useState(false)
    const handleCloseConfirmReady = () => setShowConfirmReady(false)
    const handleShowConfirmReady = (row) => {
        setDataDtlPeriksa(row)
        setShowConfirmReady(true)
    }
    const [loadingReady, setLoadingReady] = useState(false)
    const [showSaveReadySuccess, setShowSaveReadySuccess] = useState(false)
    const [showSaveReadyFailed, setShowSaveReadyFailed] = useState(false)

    const handleClickSaveReady = async () => {
        setLoadingReady(true)
        try {
            let jsonDtlPeriksa = {
                ...dataDtlPeriksa,
                isUptCanCheck: 'Y'
            }
            const res = await nonLalinService.saveNonlalinDtlPeriksa(jsonDtlPeriksa)
            if (res.data.kode === '200') {
                setShowConfirmReady(false)
                setShowSaveReadySuccess(true)
            } else {
                setShowConfirmReady(false)
                setShowSaveReadyFailed(true)
            }
        } catch (error) {
            setShowConfirmReady(false)
            setShowSaveReadyFailed(true)
        }
        setLoadingReady(false)
    }

    const handleClickSaveReadySuccess = () => {
        fetchAllData()
        setShowSaveReadySuccess(false)
    }

    const handleClickSaveReadyFailed = () => {
        setShowSaveReadyFailed(false)
    }

    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const handleCloseConfirmDelete = () => setShowConfirmDelete(false)
    const handleShowConfirmDelete = (row) => {
        setDataDtlPeriksa(row)
        setShowConfirmDelete(true)
    }
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false)
    const [showDeleteFailed, setShowDeleteFailed] = useState(false)

    const handleClickDelete = async () => {
        try {
            let jsonData = {
                nomorAju: dataDtlPeriksa.trNonlalinDtlPeriksaPK.nomorAju,
                seri: dataDtlPeriksa.trNonlalinDtlPeriksaPK.seri,
                seriTarif: dataDtlPeriksa.trNonlalinDtlPeriksaPK.seriTarif
            }
            const resDelete = await nonLalinService.deleteNonlalinDtlPeriksa(jsonData)
            if (resDelete.data.kode === '200') {
                setShowConfirmDelete(false)
                setShowDeleteSuccess(true)
            }
            
        } catch (error) {
            setShowConfirmDelete(false)
            setShowDeleteFailed(true)            
        }
    }

    const handleClickDeleteSuccess = () => {
        fetchAllData()
        setShowDeleteSuccess(false)
        setShowConfirmDelete(false)
    }

    const handleClickDeleteFailed = () => {
        fetchAllData()
        setShowDeleteFailed(false)
    }

    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <DataTable
                        customStyles={{ headCells: { style: { 'background-color': '#717475', 'color': 'white' } } }}
                        columns={columns}
                        data={listData}
                        persistTableHead={true}
                        highlightOnHover
                    />
                </Card.Body>
            </Card>
            {
                showConfirmNotReady &&
                <SweetAlert
                    title="Pengujian Tidak Siap Dilakukan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingNotReady ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveNotReady}
                    onCancel={handleCloseConfirmNotReady}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingNotReady}
                >
                    {loadingNotReady && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveNotReadySuccess &&
                <SweetAlert
                    success
                    title="Proses Berhasil Disimpan"
                    onConfirm={handleClickSaveNotReadySuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveNotReadyFailed &&
                <SweetAlert
                    danger
                    title="Proses Gagal Disimpan"
                    onConfirm={handleClickSaveNotReadyFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmReady &&
                <SweetAlert
                    title="Pengujian Siap Dilakukan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingReady ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveReady}
                    onCancel={handleCloseConfirmReady}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingReady}
                >
                    {loadingReady && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveReadySuccess &&
                <SweetAlert
                    success
                    title="Proses Berhasil Disimpan"
                    onConfirm={handleClickSaveReadySuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveReadyFailed &&
                <SweetAlert
                    danger
                    title="Proses Gagal Disimpan"
                    onConfirm={handleClickSaveReadyFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmDelete &&
                <SweetAlert
                    title="Hapus Data Pemeriksaan?"
                    warning
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickDelete}
                    onCancel={handleCloseConfirmDelete}
                    focusCancelBtn
                    btnSize="sm"
                >Data Pemeriksaan : {dataDtlPeriksa !== null ? dataDtlPeriksa.nmTarif : ''}</SweetAlert>
            }
            {
                showDeleteSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Pemeriksaan Berhasil"
                    onConfirm={handleClickDeleteSuccess}
                    btnSize="sm"
                />
            }
            {
                showDeleteFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Pemeriksaan Gagal"
                    onConfirm={handleClickDeleteFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ExpandableComponentNonLalinPeriksa